import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export const CursorTriggerEvents = {
    RegionLeave: 'cursor:region:leave',
    RegionEnter: 'cursor:region:enter',
}

export default class CursorTrigger {
    constructor(element, options = {}) {
        this.element = element
        this.options = {
            ...options,
        }

        this.state = {
            clientX: 0,
            clientY: 0,
            disabled: false,
            focused: false,
        }

        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
        this.element.addEventListener('mousemove', this.handleMouseMove)
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        // this.element.style.cursor = 'none'
    }

    destroy() {
        this.element.removeEventListener('mouseenter', this.handleMouseEnter)
        this.element.removeEventListener('mouseleave', this.handleMouseLeave)
        this.element.removeEventListener('mousemove', this.handleMouseMove)
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
        // this.element.removeAttribute('style')
    }

    handleMouseMove = (event) => {
        if (!this.state.focused) {
            return
        }

        this.state.clientX = event.clientX
        this.state.clientY = event.clientY
    }

    handleMouseLeave = () => {
        this.leave()
    }

    handleMouseEnter = () => {
        this.enter()
    }

    handleScroll = ({ offset }) => {
        if (!this.state.focused) {
            return
        }

        this.check()
    }

    handleResize = () => {
        this.resize()
    }

    leave() {
        if (this.state.disabled) {
            return
        }

        this.state.focused = false

        EventBus.emit(CursorTriggerEvents.RegionLeave)
    }

    enter() {
        if (this.state.disabled) {
            return
        }

        this.state.focused = true

        EventBus.emit(CursorTriggerEvents.RegionEnter, { ...this.options })
    }

    resize() {
        const box = this.element.getBoundingClientRect()
        const offset = Scroll.getScroll().y

        this.state.top = box.top + offset
        this.state.right = box.left + box.width
        this.state.bottom = this.state.top + box.height
        this.state.left = box.left

        if (this.options.onResize) {
            this.state = {
                ...this.state,
                ...this.options.onResize({...this.state})
            }
        }

        this.check()
    }

    check() {
        if (this.state.disabled) {
            return
        }

        const y = Scroll.getScroll().y

        if (
            this.state.clientX < this.state.left ||
            this.state.clientX > this.state.right ||
            this.state.clientY < this.state.top - y ||
            this.state.clientY > this.state.bottom - y
        ) {
            this.leave()
        }
    }

    disable() {
        this.leave()
        this.state.disabled = true
    }

    enable() {
        this.state.disabled = false
    }
}
